import type { DeviceType } from './device-type'
import type { IAssetOption, IIapOption, ITranslationOption } from './option'
import type {
  IEmbeddedUiFormValue,
  ITemplate,
  Orientation,
  TEMPLATE_TYPE,
  IPlatformDependentProperties,
} from './template'

type PlaceholderValueType = {
  placeholder: string
  value?: string
}

type PlaceholderIdType = {
  id?: string
  placeholder: string
}

interface AssetsValuesType extends PlaceholderIdType {
  is_stopped?: boolean
}

export enum PAGE_CONTAINER_STATUS {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  COMPILED = 'compiled',
  DRAFT = 'draft',
  PREPARED = 'prepared',
  STOPPED = 'stopped',
}

export interface IPageContainer {
  app_key: string
  capabilities?: string[]
  created_at: string
  created_by: string
  device_type: DeviceType
  has_stopped_asset: boolean
  is_unity: boolean
  navigation_target_outputs: string[]
  orientation: Orientation
  placeholder_actions_values: PlaceholderValueType[] | null
  placeholder_asset_values: AssetsValuesType[] | null
  placeholder_color_values: PlaceholderValueType[] | null
  placeholder_embedded_ui_values:
    | {
        iaps: string[]
        id: string
        navigation_targets: string[]
        placeholder: string
      }[]
    | null
  placeholder_iap_values: PlaceholderIdType[] | null
  placeholder_rules:
    | {
        created_at: string
        created_by: string
        placeholder_key: string
        placeholder_type: string
        rule_key: string
        template_key: string
        type: string
        updated_at: string
        updated_by: string
        value: string
      }[]
    | null
  placeholder_text_values:
    | {
        placeholder: string
        text: string
        translation_key: string
      }[]
    | null
  platform_dependant_properties: IPlatformDependentProperties | null
  requirements: string[]
  screenshot_file_ids: string[] | null
  screenshot_file_urls: string[] | null
  status: PAGE_CONTAINER_STATUS
  swipeable: boolean
  template: ITemplate | null
  template_key: string
  template_version: string
  title: string
  type: TEMPLATE_TYPE
  updated_at: string
  updated_by: string
  uuid: string
}

export type IPageContainerCreateUpdate = {
  actions?: PlaceholderValueType[]
  appKey?: string
  assets?: AssetsValuesType[]
  colors?: PlaceholderValueType[]
  deviceType?: DeviceType
  embedded_uis?: {
    iaps: string[]
    id: string
    navigation_targets: string[]
    placeholder: string
  }[]
  iaps?: PlaceholderIdType[]
  isUnity: boolean
  screenshotFileIds: string[]
  templateKey?: string
  templateVersion: string
  title?: string
  translations?: { placeholder: string; text?: string; translation_key?: string }[]
}

export type IPlaceholderMap = Record<
  string,
  {
    action?: string
    asset?: IAssetOption
    color?: string
    embeddedUi?: IEmbeddedUiFormValue
    iap?: IIapOption
    translation?: ITranslationOption
  }
>

export interface IPageContainerDetails extends IPageContainer {
  placeholders: IPlaceholderMap
}

export interface IPlaceholderFilters {
  errorOnly: boolean
  uncompletedOnly: boolean
}

export type PageContainerParamId = string | 'creation' | 'duplication'

export interface IPageContainerFormError {
  error: string
  key: string
}
